import styled from 'styled-components';
import { SessionManager } from '../../../../../../utils/session-manager';
import React, { ReactNode } from 'react';
import AnalyticsService from '../../../../../../analytics/AnalyticsService';
import { createSessionInfo } from '../../../../../../analytics/payload';
import { logError } from '../../../../../../utils/log-utils';

export const DropDown = (props: {
  id: number;
  title: string;
  content: ReactNode[];
  expanded: null | number;
  setExpanded: any;
  category?: string;
}) => {
  const isExpanded = props.expanded === props.id;
  const trackingId = props.category
    ? `dropdown_${props.category}_${props.id}`
    : `dropdown_${props.id}`;

  const handleDropdownClick = async (e: React.MouseEvent) => {
    props.setExpanded(isExpanded ? null : props.id);
    SessionManager.setButtonId(trackingId);

    try {
      const urlParams = new URLSearchParams(window.location.search);
      const query = urlParams.toString();
      const sessionInfo = createSessionInfo(0, query);
      await AnalyticsService.sendLandingLog(sessionInfo);
    } catch (error) {
      logError('Error sending FAQ analytics:', error);
    }
  };

  return (
    <Wrapper id={trackingId} onClick={handleDropdownClick} data-tracking='true'>
      <Title>
        <TitleLabel expanded={isExpanded}>{props.title}</TitleLabel>
        <p>
          <ButtonNaked id={`${trackingId}_button`} expanded={isExpanded}>
            {isExpanded ? '-' : '+'}
          </ButtonNaked>
        </p>
      </Title>
      {isExpanded && (
        <Content>
          {props.content.map((element, index) => (
            <React.Fragment key={index}>{element}</React.Fragment>
          ))}
        </Content>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-top: 17px;
  border-bottom: 1px solid #283288;
  width: 100%;

  @media (min-width: 768px) {
    cursor: pointer;
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  cursor: pointer;
`;

const Content = styled.div`
  > p {
    font-family: 'League Spartan', sans-serif !important;
    max-width: 90%;
    text-align: left;
    font-size: 16px;
    line-height: 1.2;
    color: ${(props) => props.theme.landing.colors.primary};
    padding-bottom: 18px;
  }
  @media (min-width: 768px) {
    > p {
      font-family: 'League Spartan', sans-serif !important;
      margin-top: 10px;
      line-height: 1.5;
      font-size: 20px;
    }
  }
`;

export const ButtonNaked = styled.span<{ expanded?: boolean }>`
  display: block;
  background: transparent;
  padding: 0;
  margin: 0;
  min-width: 0;
  font-weight: bold;
  font-size: 2.4rem;
  color: ${(props) => props.theme.landing.colors.primary};
`;

export const TitleLabel = styled.p<{ expanded: boolean }>`
  font-family: 'League Spartan', sans-serif !important;
  max-width: 90%;
  text-align: left;
  color: ${(props) => props.theme.landing.colors.primary};
  font-weight: ${(props) => (props.expanded ? 'bold' : 'normal')};

  @media (min-width: 768px) {
    font-size: 1.4rem;
  }
`;
